import { useQuery, useQueryClient } from '@tanstack/react-query';
import { fetchPublicStockSetupStatus, fetchStockSetupStatus } from '../services/stockSetupService';
import { getShopBranchIdFromToken } from '../auth/authUtils';
import { useConfig } from '../context/ConfigContext';

export const stockSetupQueryKey = (shopBranchId, isPublic) => [
    'stockSetupStatus',
    shopBranchId ?? 'unknown',
    isPublic ? 'public' : 'private',
];

export const useStockSetup = (options = {}) => {
    const { features } = useConfig();
    const stockModuleActive = features.some(
        (feature) => feature.name === 'STOCK' && (feature.status === true || feature.status === 1)
    );
    const isPublic = options.publicRoute === true;
    const sessionBranchId = getShopBranchIdFromToken();
    const shopBranchId = isPublic
        ? options.shopBranchId
        : (options.shopBranchId ?? sessionBranchId);

    const query = useQuery({
        queryKey: stockSetupQueryKey(shopBranchId, isPublic),
        queryFn: () => (isPublic
            ? fetchPublicStockSetupStatus(shopBranchId)
            : fetchStockSetupStatus()),
        enabled: stockModuleActive
            && (options.enabled !== false)
            && Boolean(shopBranchId)
            && (!isPublic || Boolean(shopBranchId)),
        staleTime: 30 * 1000,
        ...options,
    });

    const status = query.data;
    const isSetupStatusLoading = query.isPending && status == null;
    const stockControlEnforced = Boolean(status?.stockControlEnforced);
    const stockSetupCompleted = Boolean(status?.stockSetupCompleted);
    const productsWithoutStock = status?.productsWithoutStock ?? 0;
    const productsWithZeroStock = status?.productsWithZeroStock ?? 0;

    return {
        ...query,
        stockModuleActive,
        isSetupStatusLoading,
        stockControlEnforced,
        stockSetupCompleted,
        productsWithoutStock,
        productsWithZeroStock,
        status,
    };
};

export const invalidateStockSetupStatus = (queryClient) => {
    queryClient.invalidateQueries({ queryKey: ['stockSetupStatus'] });
};
